import { useBooleanFlag } from "@apac/feature-flags";
import { useDialog } from "@apac/hooks";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FeatureFlagNames, getCardByBin } from "@hsbc/utilities";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface DeleteCardDialogProps {
  bin: string;
  onDeleteClick: () => void;
}

export const DeleteCardDialog: React.FC<DeleteCardDialogProps> = ({
  bin,
  onDeleteClick,
}) => {
  const { t } = useI18nContext();
  const disableBinCheck = useBooleanFlag(FeatureFlagNames.DISABLE_BIN_CHECK);
  const [block, cn] = useModuleBEM(styles, "DeleteCardDialog");

  const card = getCardByBin(bin, disableBinCheck);
  const { open, onClose, onOpen } = useDialog();

  return (
    <Dialog open={open}>
      <DialogTrigger className={cn("remove-button")} onClick={onOpen}>
        {t("remove")}
      </DialogTrigger>

      <DialogContent
        className={block}
        showCloseButton={false}
        showHeaderBottomBorder={false}
        title={t("wallet.cards.deleteCardTitle", { cardName: card?.name })}
      >
        <div className={cn("container")}>
          <span>{t("wallet.cards.areYouSureLabel")}</span>

          <div className={cn("footer")}>
            <button
              className={clsx(cn("cancel-button"), cn("button"))}
              onClick={onClose}
            >
              {t("wallet.cards.cancelDeleteCard")}
            </button>
            <button
              className={clsx(cn("confirm-button"), cn("button"))}
              onClick={onDeleteClick}
            >
              {t("wallet.cards.confirmDeleteCard")}
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
